<p-block-ui [target]="mediaSourcesDiv" [blocked]="loading"></p-block-ui>
<p-tabView>
  <p-tabPanel header="Seleziona file esistente">
    <div
      class="drop-area"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <div *ngIf="dragging" class="drag-overlay">Rilascia il file qui</div>

      <div class="flex flex-row justify-content-between">
        <app-input type="text" actionButtonLabel="Cerca" placeholder="Cerca..." inputWidth="350px"
                   [debounceDelay]="1000"
                   [model]="genericText$.value" (modelChange)="genericText$.next($event)"
                   [showLength]="false"
        ></app-input>
        <div style="width: 200px">
          Dimensione delle anteprime
          <p-slider [(ngModel)]="iconSize" max="200" min="50" step="10"></p-slider>
        </div>
        <app-checkbox label="Mostra il cestino"
                      labelWidth="auto"
                      [model]="showDeleted$.value" (modelChange)="showDeleted$.next($event)"></app-checkbox>
      </div>
      <hr>
      <app-blockable-div #mediaSourcesDiv>
        <div class="flex flex-row flex-wrap">
          @for (media of mediaSources; track media.mediaSourceId) {
            <div class="media-asset" [style.width]="iconSize + 'px'" [style.height]="iconSize + 'px'"
                 [pTooltip]="media.name">
              @if (media.mediaSourceType === MediaSourceType.Image) {
                <img [src]="media.fullPath" class="img-fluid"
                     [class.selected]="selectedMediaSource?.mediaSourceId == media.mediaSourceId"
                     (click)="selectMedia(media)">
                <p *ngIf="iconSize >= 100" class="title">{{ media.name }}</p>
              } @else {
                <div class="media-asset generic-media-asset"
                     [class.selected]="selectedMediaSource?.mediaSourceId == media.mediaSourceId"
                     (click)="selectMedia(media)">
                  <span class="pi pi-file"></span>
                </div>
                <p *ngIf="iconSize >= 100" class="title">{{ media.name }}</p>
              }
            </div>
          }
        </div>
        <br>
        <br>
        <p-paginator [totalRecords]="mediaSourcesCount"
                     [rowsPerPageOptions]="[10, 20, 50]"
                     [rows]="paginationSize"
                     (onPageChange)="onPageChange($event)"></p-paginator>
      </app-blockable-div>
    </div>
  </p-tabPanel>
  <p-tabPanel header="Carica nuovo file">
    <p-fileupload name="file" url="your-upload-url" mode="advanced"
                  (uploadHandler)="onUpload($event)"
                  (onUpload)="onUpload($event)"
                  [accept]="accept"
                  [multiple]="multipleUpload"
                  [maxFileSize]="maxFileSize"
                  [customUpload]="true"
                  [auto]="true"></p-fileupload>
  </p-tabPanel>
</p-tabView>

